export enum ActorTypes {
  Interne = 'AC1',
  Partenaire = 'AC2',
  Oblige = 'AC3',
  SousTraitant = 'AC4',
  Apporteur = 'AC5',
  Mandataire = 'AC6',
  Superviseur = 'AC7'
}
